import React, { ReactNode } from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import styled from 'styled-components/macro';
import { sanitizeUrl } from '../../shared/utils/sanitizationUtils';

const UrlButtonContainer = styled.span`
    font-size: 14px;
`;

const StyledButton = styled(Button)`
    > :hover {
        text-decoration: underline;
    }
    &&& {
        padding-bottom: 0px;
    }
    padding-left: 12px;
    padding-right: 12px;
`;

interface Props {
    href: string;
    children: ReactNode;
    onClick?: () => void;
}

const NOOP = () => {};

export default function UrlButton({ href, children, onClick = NOOP }: Props) {
    // Sanitize URL to prevent XSS attacks
    const safeHref = sanitizeUrl(href);

    // Don't render button if URL is unsafe
    if (!safeHref) {
        return null;
    }

    return (
        <UrlButtonContainer>
            <StyledButton
                type="link"
                href={safeHref}
                target="_blank"
                className="mr-3"
                onClick={onClick}
                rel="noreferrer noopener"
                aria-label={`${children}`}
            >
                {children} <ArrowRightOutlined aria-hidden="true" style={{ fontSize: 12 }} />
            </StyledButton>
        </UrlButtonContainer>
    );
}
